import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { getMaxNumberByKey } from 'utilitys/helpers/general';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';
import { useProjectTreeStore } from 'store/projectContract.store';

import { ProgramStatusUrlParams } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';

export const PageWidgetWrapper = ({ children }) => {
    const { id, versionToCompareId } = useParams<ProgramStatusUrlParams>();
    // convert version hashes to string with comma between
    const hashcode = [id, versionToCompareId].filter((v): v is string => Boolean(v)).join(',');
    const { versionList: versionFromHashMap } = useHashmapConverter(hashcode);
    const { project, contract } = useProjectTreeStore();
    const projectId = project?.id;
    const contractId = contract?.id;
    const latestVersionId = versionFromHashMap[0]?.versionDbId;
    const compareVersionId = versionFromHashMap[1]?.versionDbId;
    const globalFilterData = useGlobalFilterDataStore((state) => state.globalFilterData);
    const maxLevel = useMemo(
        () => getMaxNumberByKey({ list: versionFromHashMap, key: 'maxLevel' }),
        [versionFromHashMap],
    );

    return React.Children.map(children, (child) => {
        return child
            ? React.cloneElement(child, {
                  projectId,
                  contractId,
                  latestVersionId,
                  compareVersionId,
                  globalFilterData,
                  maxLevel,
              })
            : null;
    });
};
